import { render, staticRenderFns } from "./securityQuestion.vue?vue&type=template&id=1d611cbc&"
import script from "./securityQuestion.vue?vue&type=script&lang=js&"
export * from "./securityQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports